import { Helmet } from "react-helmet-async";
import { MySelector } from "../../redux/store";
import { useLocation } from "react-router-dom";

interface MetaTagsProps {
  fileId?: string;
  fileUrl?: string;
}

const MetaTags = ({ fileId, fileUrl }: MetaTagsProps) => {
  const { data: eventData } = MySelector((state) => state.event);
  const location = useLocation();
  const currentUrl = window.location.href;
    console.log("eventData:", eventData)
  // Default meta data
  let title = "It's Forever";
  let description = "Your memories, forever preserved";
  let imageUrl = "";

  // If we have event data, use it for meta tags
  if (eventData && eventData !== "null") {
    title = eventData.name || title;
    description = eventData.description || description;
    if (eventData.coverPhotoLink) {
      imageUrl = eventData.coverPhotoLink;
    }
  }

  // If this is a specific file being shared, use that file's image instead
  if (fileUrl) {
    imageUrl = fileUrl;
  }

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{title}</title>
      <meta name="title" content={title} />
      <meta name="description" content={description} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={currentUrl} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      {imageUrl && <meta property="og:image" content={imageUrl} />}

      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={currentUrl} />
      <meta property="twitter:title" content={title} />
      <meta property="twitter:description" content={description} />
      {imageUrl && <meta property="twitter:image" content={imageUrl} />}
    </Helmet>
  );
};

export default MetaTags;